import {
  Component,
  Input,
  EventEmitter,
  Output,
  OnDestroy,
  OnInit
} from '@angular/core';
import {
  KeyBoolean,
  UserPreferencesState,
  UserPreferencesStateKey
} from '@approot/models';
import {
  LegService,
  ProductsConfigService,
  UserStorageService
} from '@approot/services';
import {
  isBuyPosition,
  isSellPosition,
  SubscriptionSink
} from '@approot/utilities';

type Rows =
  | 'premiumQuoteCurrencyInPercent'
  | 'premiumQuoteCurrencyPips'
  | 'premiumBaseCurrency'
  | 'premiumBaseCurrencyInPercent'
  | 'upfrontPremiumBsMid'
  | 'spotDelta'
  | 'spotDeltaPercent'
  | 'forwardDelta'
  | 'forwardDeltaPercent'
  | 'brokerDelta'
  | 'brokerDeltaPercent'
  | 'gamma'
  | 'vega'
  | 'riskies'
  | 'flies';

@Component({
  selector: 'pricing-results-display',
  templateUrl: './pricing-results-display.component.html',
  styleUrls: ['./pricing-results-display.component.scss']
})
export class PricingResultsDisplayComponent implements OnDestroy, OnInit {
  @Input() pricedLeg: any;
  @Input() productType: any;
  @Input() position: string;
  @Input() baseCurrency: string;
  @Input() quoteCurrency: string;
  @Input() showMid = false; // toggle to show the mid or not
  @Output() showMidEmit = new EventEmitter<boolean>(); // if mid is toggled emit this to leg
  public isBidActive: boolean;
  public isAskActive: boolean;
  private pricingDisplaySettings: { [key: string]: boolean } = {};
  private subsink = new SubscriptionSink();
  private availableResults: KeyBoolean = {};

  constructor(
    private legService: LegService,
    private userStorageService: UserStorageService,
    private productsConfigService: ProductsConfigService
  ) {
    this.subsink.sink = this.userStorageService
      .storeChangesObservable<UserPreferencesState>(UserPreferencesStateKey)
      .subscribe(prefs => {
        this.pricingDisplaySettings = prefs['PricingDisplayPrefs'];
      });
  }
  ngOnInit(): void {
    this.productsConfigService.pricingResultsInfo.resultSpecifications.forEach(
      result => (this.availableResults[result.shortName] = true)
    );
    this.isBidActive = isSellPosition(this.position);
    this.isAskActive = isBuyPosition(this.position);
  }

  ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }

  public isRowEnabled(name: Rows): boolean {
    const ret = this.pricingDisplaySettings[name];
    return (ret ?? true) && this.availableResults[name];
  }

  toggleShowMid() {
    this.showMid = !this.showMid;

    this.showMidEmit.emit(this.showMid);
  }

  get pricingResultsExpanded() {
    return this.legService.pricingResultsExpanded;
  }
}
